import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import DateRow from './DateRow.js';
import DayHeader from './DayHeader.js';
import TodoList from '../comps/TodoList';

import jsCalendar from 'js-calendar';

class Calendar extends Component {

  months = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  state = {
    weeks : [],
    month : "",
    selectedTodo : ""
  }

  constructor(props) {
    super(props);

    var generator = new jsCalendar.Generator({onlyDays: true, weekStart: 0, lang: 'en'});
    var today = new Date();
    var calendar = generator(today.getFullYear(), today.getMonth());

    var weeks = []
    for (var i = 0; i < calendar.cells.length; i += 7) {
      var week = calendar.cells.slice(i,i+7);
      weeks.push(week);
    }

    this.state = {
      weeks : weeks,
      month : this.months[today.getMonth()],
      selectedTodo : ""
    };
  }

  onCellClick = (cell, groupKey) => {
    this.setState({selectedTodo: groupKey})
  }

  onBack = () => {
    this.setState({selectedTodo: ""})
  }

  render() {

    var content

    if (this.state.selectedTodo !== "")
    {
      content = (
        <Box px={2}>
          <Button variant="contained" color="secondary" fullWidth onClick={this.onBack}>Back</Button>
          <TodoList group={this.state.selectedTodo}/>
        </Box>
      );
    }
    else
    {
      var weekRows = []
      for (var i = 0; i < this.state.weeks.length; i++) {
        var week = this.state.weeks[i];
        week.key = i;
        weekRows.push(<DateRow key={i} week={week} onCellClick={this.onCellClick}/>);
      }

      content = (
        <Box>
          <Grid container justify="center">
            <DayHeader day="Sun"/>
            <DayHeader day="Mon"/>
            <DayHeader day="Tue"/>
            <DayHeader day="Wed"/>
            <DayHeader day="Thu"/>
            <DayHeader day="Fri"/>
            <DayHeader day="Sat"/>
          </Grid>
          <Grid container justify="center">
            {weekRows}
          </Grid>
        </Box>);
    }


    return (
      <Box pt={2}>
        <Box pb={2}>
          <Typography variant="h5" align="center">{this.state.month}</Typography>
        </Box>
        {content}
      </Box>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/comps/Calendar.js